/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import VueRouter from 'vue-router';

Vue.use(VueRouter);

import VueConfirmDialog from 'vue-confirm-dialog';

import routes from './routes';

import _ from "lodash";

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import { faSpinner, faEdit , faAdd, faCircleUser, faArrowUpRightFromSquare, faCircleCheck} from '@fortawesome/free-solid-svg-icons'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


Vue.use(VueConfirmDialog);
// Vue.component('vue-confirm-dialog', VueConfirmDialog.default);

import DisableAutocomplete from 'vue-disable-autocomplete';

Vue.use(DisableAutocomplete);


library.add( faSpinner, faEdit, faAdd, faCircleUser, faArrowUpRightFromSquare, faCircleCheck );

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.prototype.$eventHub = new Vue();
    //new Vue(); // Global event bus
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));


// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import CommonHelper from "./mixins/CommonHelper.js";

Vue.mixin(CommonHelper);

const router =  new VueRouter({
    mode:'history',
    routes
});



// router.beforeEach((to, from, next) => {
//     /* must call `next` */
//     console.log(to.name);
//     if(to.name !== 'sign_in') {
//         if(CommonHelper.methods.isLoggedIn()) {
//             next();
//         }
//     } else {
//         next()
//     }
// });

CommonHelper.methods.beforeEachRoute(router);


const app = new Vue({
    el: '#app',
    router: router
});
